const researchFundProjects = [
  {
    "title": "Integrated and Multidisciplinary Investigations and Early Warning of High-Risk Landslides Using Space, Air, And Ground-Based Remote Sensing",
    "domain": "Remote Sensing and GIS",
    "academia": "Institute of Geology, University of Azad Jammu and Kashmir, Muzaffarabad",
    "industry": "Planning & Development Department, Govt. of AJ&K",
    "summary": "This project was undertaken to develop a comprehensive framework for landslide risk reduction through the integration of advanced technologies and methodologies, including InSAR remote sensing, UAV-based surveys, geophysical and geotechnical investigations, numerical modeling, and the implementation of an early warning system.",
    "sdgs": [
      15
    ],
    "gallery": "https://drive.google.com/drive/folders/1R9AqPp8Ug34NwEUDm-2y-Yn4lermJukQ",
    "logos": [
      "/research-fund/project-01/logo-1.png",
      "/research-fund/project-01/logo-2.jpg"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-15.png"
    ]
  },
  {
    "title": "Development of a High-Resolution Nano-g MEMS Accelerometer for Seismic Surveying and Mineral Exploration and Low Power, High-Performance Indigenous MEMS Gyroscope for Application in Attitude & Orbital Control Systems (AOCS) in Satellite Systems",
    "domain": "Remote Sensing and GIS",
    "academia": "Sir Syed CASE Institute of Technology",
    "industry": "NESCOM",
    "summary": "This project focuses on the development of a high-resolution Nano-g accelerometer for applications in Remote Sensing and GIS, including inertial navigation, earthquake detection and monitoring, seismological studies, seismic surveying, spacecraft guidance, and geophysical sensing.",
    "sdgs": [
      4,
      5,
      8,
      9,
      12,
      17
    ],
    "gallery": "https://drive.google.com/drive/folders/1C54os5dqzqQtJEZUoesHobX4tlLOnmJP",
    "logos": [
      "/research-fund/project-02/logo-1.png",
      "/research-fund/project-02/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-4.png",
      "/research-fund/sdgs/sdg-5.png",
      "/research-fund/sdgs/sdg-8.png",
      "/research-fund/sdgs/sdg-9.png",
      "/research-fund/sdgs/sdg-12.png",
      "/research-fund/sdgs/sdg-17.png"
    ]
  },
  {
    "title": "Remote-SOS4EEZ: Remote Sensing for Oil Spill Detection in Pakistan�s Exclusive Economic Zone",
    "domain": "Remote Sensing and GIS",
    "academia": "Information Technology University of the Punjab (ITU), Lahore",
    "industry": "Lyzk Global Pvt. Ltd.",
    "summary": "This project aims to develop an automated toolchain for detecting oil spills using radar and optical satellite imagery acquired from the Sentinel-1 and Sentinel-2 constellations. It will establish a classification framework for oil spill detection and enable pixel-wise multi-label classification.",
    "sdgs": [
      14,
      12
    ],
    "gallery": "https://drive.google.com/drive/folders/1xUQMv8zLiH794vuPlY6n1Ujf0UcYI816",
    "logos": [
      "/research-fund/project-03/logo-1.png",
      "/research-fund/project-03/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-14.png",
      "/research-fund/sdgs/sdg-12.png"
    ]
  },
  {
    "title": "Improving the Electricity Distribution System through Dynamic GIS-Based Asset Management",
    "domain": "Remote Sensing and GIS",
    "academia": "Lahore University of Management Sciences (LUMS)",
    "industry": "Central Power Purchasing Agency, Pakistan",
    "summary": "This project aims to develop a GIS-enabled software tool for the preventive maintenance of distribution system assets. The tool will offer a dynamic visualization of the distribution grid, enabling DISCOs to perform timely system updates and reconfigurations before asset overloading occurs, thereby mitigating the risk of grid failure. By monitoring the utilization of power distribution assets, the GIS-based tool will enhance system reliability, support informed decision-making, and contribute to reducing operational costs for utility providers.",
    "sdgs": [
      1,
      3,
      7,
      8,
      9,
      11,
      13,
      17
    ],
    "gallery": "https://drive.google.com/drive/folders/1A9LCvuoU0Tk2vXDFFwKUvBIrMvZKJKdP",
    "logos": [
      "/research-fund/project-04/logo-1.jpg",
      "/research-fund/project-04/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-1.png",
      "/research-fund/sdgs/sdg-3.png",
      "/research-fund/sdgs/sdg-7.png",
      "/research-fund/sdgs/sdg-8.png",
      "/research-fund/sdgs/sdg-9.png",
      "/research-fund/sdgs/sdg-11.png",
      "/research-fund/sdgs/sdg-13.png",
      "/research-fund/sdgs/sdg-17.png"
    ]
  },
  {
    "title": "Development of a Smart Groundwater Monitoring System to Calibrate and Validate GRACE Data for Real-Time Assessment of Groundwater Storage Depletion",
    "domain": "Remote Sensing and GIS",
    "academia": "International Islamic University, Islamabad",
    "industry": "Water & Power Development Authority, Pakistan",
    "summary": "The overall objective of this project is to develop innovative and cost-effective socio-technical approaches for a smart groundwater monitoring system capable of real-time observation of groundwater depletion. The system will integrate in-situ measurements with data from the Gravity Recovery and Climate Experiment (GRACE) satellite mission to accurately estimate groundwater storage depletion at a regional scale. This smart solution will provide high spatial and temporal resolution monitoring to support sustainable water resource management.",
    "sdgs": [
      6
    ],
    "gallery": "https://drive.google.com/drive/folders/1dxMB5y1cN0hv20E_czGjJT3GxNBe3iBX",
    "logos": [
      "/research-fund/project-05/logo-1.png",
      "/research-fund/project-05/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-6.jfif"
    ]
  },
  {
    "title": "An Autonomous IOT-Based Approach Toward Monitoring and Subsequently Identifying Invasive Dengue/Zika Vector Prevalence and Possible Dengue Outbreak Areas",
    "domain": "Remote Sensing and GIS",
    "academia": "National University of Sciences & Technology, Islamabad",
    "industry": "ROWAN TEK Pvt. Ltd.",
    "summary": "In its initial phase, this application aims to identify disease hotspots and subsequently support the control of potential outbreaks. It will further recommend environmental management practices based on the data collected and analyzed, enabling more effective disease prevention and response. Given that this project addresses a critical global health issue, its implementation holds the potential for widespread adoption and significant positive impact.",
    "sdgs": [
      3,
      9,
      11,
      13
    ],
    "gallery": "https://drive.google.com/drive/folders/1XRJgDpyIFt0PAkNGYUXjQHH36Vmmr26P",
    "logos": [
      "/research-fund/project-06/logo-1.png",
      "/research-fund/project-06/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-3.png",
      "/research-fund/sdgs/sdg-9.png",
      "/research-fund/sdgs/sdg-11.png",
      "/research-fund/sdgs/sdg-13.png"
    ]
  },
  {
    "title": "Attitude Determination Through Satellite Tracking for Aerial Platforms",
    "domain": "Position, Navigation, and Timing",
    "academia": "Institute of Space Technology, Islamabad",
    "industry": "NESCOM (AWC)",
    "summary": "This project aims to develop a fully indigenous Attitude Determination (AD) system leveraging GNSS signals. The solution will consist of a custom-built FPGA-based hardware module integrated with entirely locally developed onboard software. The system will be designed for seamless installation on both airborne and land-based platforms.",
    "sdgs": [
      8,
      5
    ],
    "gallery": "https://drive.google.com/drive/folders/180jtokKnRZoZRutxBATyhvWmaB56aLt3",
    "logos": [
      "/research-fund/project-07/logo-1.jpg",
      "/research-fund/project-07/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-8.png",
      "/research-fund/sdgs/sdg-5.png"
    ]
  },
  {
    "title": "High-precision location identification for multiple applications using deep neural networks by augmenting GPS with terrain knowledge",
    "domain": "Position, Navigation, and Timing",
    "academia": "Karachi Institute of Economics and Technology",
    "industry": "DataLog Pvt. Ltd.",
    "summary": "This project aims to develop advanced algorithms for highly accurate target location determination, achieving precision within �1 meter. The approach will leverage deep neural networks enhanced by Terrain Referenced Navigation (TRN) techniques to improve geolocation accuracy and reliability.",
    "sdgs": [
      3,
      9,
      11
    ],
    "gallery": "https://drive.google.com/drive/folders/1SOZAxlN0McFFTeGKLH_vnhYvVMtOI-mf",
    "logos": [
      "/research-fund/project-08/logo-1.png",
      "/research-fund/project-08/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-3.png",
      "/research-fund/sdgs/sdg-9.png",
      "/research-fund/sdgs/sdg-11.png"
    ]
  },
  {
    "title": "Detection, Analysis, and Forecasting of Sunspot Groups (Active Regions) using Advanced Machine Learning",
    "domain": "Space Applications and Advanced Systems",
    "academia": "NED University of Engineering and Technology",
    "industry": "Mareekh Dynamics, Australia",
    "summary": "The project aims to develop a machine learning-based time series forecasting algorithm to predict and validate future sunspots and active regions. In addition to forecasting, the algorithm will facilitate the analysis of key physical properties, such as sunspot areas and their evolution across the solar disc, using solar imagery.",
    "sdgs": [
      17,
      4,
      13
    ],
    "gallery": "https://drive.google.com/drive/folders/1P-65TShV39YEM1WcX_EQBWeidzAwXlt8",
    "logos": [
      "/research-fund/project-09/logo-1.png",
      "/research-fund/project-09/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-17.png",
      "/research-fund/sdgs/sdg-4.png",
      "/research-fund/sdgs/sdg-13.png"
    ]
  },
  {
    "title": "Indigenous development of Magnetometer for geomagnetic field monitoring",
    "domain": "Space Applications and Advanced Systems",
    "academia": "NED University of Engineering & Technology, Karachi",
    "industry": "SUPARCO",
    "summary": "Pakistan's current seismic monitoring capabilities remain limited, highlighting the urgent need to establish a robust geomagnetic monitoring network across the country. The indigenous development of magnetometers would significantly enhance national seismic monitoring capacity, enable comprehensive coverage, and offer valuable insights into earthquake mechanisms.",
    "sdgs": [
      9,
      11,
      13,
      17
    ],
    "gallery": "https://drive.google.com/drive/folders/1LjilkgImue_aV7CtX0X0jB3Fxhb92nHO",
    "logos": [
      "/research-fund/project-10/logo-1.png",
      "/research-fund/project-10/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-9.png",
      "/research-fund/sdgs/sdg-11.png",
      "/research-fund/sdgs/sdg-13.png",
      "/research-fund/sdgs/sdg-17.png"
    ]
  },
  {
    "title": "Development of Lightweight Sandwich Panels with Cost-Effective Techniques for Radiation-Shielded Structures of Satellites",
    "domain": "Small Satellite Technology",
    "academia": "Institute of Space Technology, Islamabad",
    "industry": "SUPARCO & NCP",
    "summary": "This proposal outlines the development of manufacturing processes for aluminum and composite sandwich panels intended for satellite subsystem components. The primary objective is to optimize a cost-effective and efficient fabrication method through the prototype development of sandwich panels, followed by rigorous testing to demonstrate their space worthiness.",
    "sdgs": [
      9,
      12,
      13,
      17
    ],
    "gallery": "https://drive.google.com/drive/folders/1OslXsJc6L3Zo1U6LShBDWxMnAehAG6qQ",
    "logos": [
      "/research-fund/project-11/logo-1.jpg",
      "/research-fund/project-11/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-9.png",
      "/research-fund/sdgs/sdg-12.png",
      "/research-fund/sdgs/sdg-13.png",
      "/research-fund/sdgs/sdg-17.png"
    ]
  },
  {
    "title": "Space Technology Outreach Short Film Production",
    "domain": "Space Popularization and Outreach",
    "academia": "Beaconhouse National University, Lahore, Pakistan",
    "industry": "Lockdown Productions",
    "summary": "This initiative aims to promote space sciences among the general public�particularly the youth�through a unique and engaging approach. As the first endeavor of its kind in Pakistan, the project will feature a film that blends real data, facts, and scientific information into a fictional narrative, presented in an entertaining and accessible format.",
    "sdgs": [
      4,
      8,
      9,
      17
    ],
    "gallery": "https://drive.google.com/drive/folders/1IdVhFcdQPG1tTg0NjNOAl1ITpoAiSzoq",
    "logos": [
      "/research-fund/project-12/logo-1.jpg",
      "/research-fund/project-12/logo-2.png"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-4.png",
      "/research-fund/sdgs/sdg-8.png",
      "/research-fund/sdgs/sdg-9.png",
      "/research-fund/sdgs/sdg-17.png"
    ]
  },
  {
    "title": "Outreach and Learning with Cosmic Ray Muons, Augmented Reality, And Astrophysics Laboratory Experiments",
    "domain": "Space Popularization and Outreach",
    "academia": "Lahore University of Management Sciences (LUMS)",
    "industry": "Khwarizmi Science Society",
    "summary": "This multifaceted project aims to promote awareness of space and particle sciences through three key components: (1) development of instruments to detect cosmic ray muons and neutrons, (2) nationwide roadshows featuring an LHC Interactive Tunnel, and (3) establishment of an astrophysics laboratory for education and research.",
    "sdgs": [
      4,
      8,
      10
    ],
    "gallery": "https://drive.google.com/drive/folders/1OmM9pRfmI5Txrdt6wPbGai0vRs8s5CI5",
    "logos": [
      "/research-fund/project-13/logo-1.jpg",
      "/research-fund/project-13/logo-2.jpg"
    ],
    "sdgImages": [
      "/research-fund/sdgs/sdg-4.png",
      "/research-fund/sdgs/sdg-8.png",
      "/research-fund/sdgs/sdg-10.png"
    ]
  }
];

export default researchFundProjects;
